<template>
  <div>
    <template v-if="showNav">
      <component
        :is="'LayoutWrapperDesktop'"
        :key="'LayoutWrapperDesktop'"
      >
        <slot />
      </component>
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  components: {
    LayoutWrapperDesktop: () => import(/* webpackChunkName: "components--layout" */ '@/components/layout/layouts/LayoutWrapperDesktop'),
  },

  data() {
    return {
      showNav: true,
      windowWidth: 0,
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        this.setNavVisibility();
      },
    },
  },

  methods: {
    setNavVisibility() {
      this.showNav = true;

      const routesWithNoNav = [
        'mobile-swipe', //
      ];

      if (routesWithNoNav.includes(this.$route.name)) {
        this.showNav = false;
      }
    },
  },
};
</script>
